/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 12.09.2016.
 */

import MetadataReducer from './reducer-metadata';

export default MetadataReducer;



// WEBPACK FOOTER //
// ./src/reducers/metadata/index.js